module.exports = __webpack_public_path__ + "static/media/IMG_2668.61b91060.JPG";